export const educationTypes = [
  {
    label: 'Course',
    value: 'course',
  },
  {
    label: 'Training',
    value: 'training',
  }
];
